import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard, EnviromentGuard } from 'common';

const routes: Routes = [
  { path: 'manage', loadChildren: () => import('./picking/manage-pick/manage-pick.module').then(m => m.ManagePickModule), canActivate: [EnviromentGuard, AuthenticationGuard] },
  { path: 'unitaryPick', loadChildren: () => import('./picking/unitary-pick/unitary-pick.module').then(m => m.UnitaryPickModule), canActivate: [EnviromentGuard, AuthenticationGuard] },
  { path: 'batchPick', loadChildren: () => import('./picking/batch-pick/batch-pick.module').then(m => m.BatchPickModule), canActivate: [EnviromentGuard, AuthenticationGuard] },
  { path: 'page', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [EnviromentGuard, AuthenticationGuard] },
  { path: 'package', loadChildren: () => import('./package/package.module').then(m => m.PackageModule), canActivate: [EnviromentGuard, AuthenticationGuard] },
  { path: 'incident', loadChildren: () => import('./incident/incident.module').then(m => m.IncidentModule), canActivate: [EnviromentGuard, AuthenticationGuard]},
  { path: 'security', loadChildren: () => import('./security/security.module').then(m => m.SecurityModule), canActivate: [EnviromentGuard] },
  { path: 'environment', loadChildren: () => import('./layout/layout-enviroment-routing.module').then(m => m.LayoutEnviromentRoutingModule) },
  { path: 'device', loadChildren: () => import('./device/device.module').then(m => m.DeviceModule)},
  { path: 'document', loadChildren: () => import('./document/document.module').then(m => m.DocumentModule)},
  { path: 'config', loadChildren: () => import('./config/config.module').then(m => m.ConfigModule)},
  { path: 'enviroment/config', redirectTo: 'environment/config' },
  { path: '**', redirectTo: 'environment/config' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }